import React, { FC } from 'react';
import _ from 'lodash';
import { Box, Heading, Text } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import s from './ExploreBanner.module.scss';

interface ExploreBannerProps {
  isMobileView?: boolean;
}

const ExploreBanner: FC<ExploreBannerProps> = ({ isMobileView }) => {
  const { t } = useTranslation();

  return (
    <Box className={`${s.bannerWrapper} ${isMobileView ? s.mobileView : ''}`}>
      <Box direction="vertical" className={s.textWrapper} gap="6px">
        <Heading as="h1">
          <Trans i18nKey={'explore-page-heading'}>
            <Text className={s.coloredText}>
              Hire a professional
              <Text light>to work on your site</Text>
            </Text>
          </Trans>
        </Heading>
        <Text light className={s.subtitle}>
          {t('explore-page-heading-subtitle')}
        </Text>
      </Box>
    </Box>
  );
};

export default ExploreBanner;
